import React from 'react';

import { balance, money } from './changeRequestFormat';

/**
 * The summary strip. No user-specific figures: these pages are shared by everyone
 * with access to the location.
 *
 * `balance_after_pending` is read off the end of the server's funding fold, floored
 * at zero; what pending demand draws beyond the pots is `event_profit_after_pending`.
 */
export default function ChangeRequestsTiles({ tiles, scoped }) {
    const afterPending = tiles.balance_after_pending;
    const eventProfit = Number(tiles.event_profit_after_pending ?? 0);

    return (
        <div className="tw-grid tw-grid-cols-1 tw-gap-3 sm:tw-grid-cols-2 lg:tw-grid-cols-4">
            <div className="bc-stat">
                <div className="bc-stat__label">{$t('Pending requests')}</div>
                <div className="bc-stat__value bc-stat__value--amber">{tiles.pending_count ?? 0}</div>
            </div>

            <div className="bc-stat">
                <div className="bc-stat__label">{$t('Pending value')}</div>
                <div className="bc-stat__value">{money(tiles.pending_value)}</div>
            </div>

            <div className="bc-stat">
                <div className="bc-stat__label">{scoped ? $t('Local contingency balance') : $t('Contingency balance')}</div>
                <div className="bc-stat__value">{balance(scoped ? tiles.local_balance : tiles.total_balance)}</div>
                {!scoped && (
                    <div className="bc-stat__sub">
                        {$t('Local {{local}} · Central {{central}}', {
                            local: balance(tiles.local_balance),
                            central: balance(tiles.central_balance),
                        })}
                    </div>
                )}
            </div>

            <div className="bc-stat">
                <div className="bc-stat__label">{$t('Balance after pending')}</div>
                {/* A pot never reads below nothing: pending demand it cannot fund falls to
                    Event profit, which shows beneath it only when there is some. */}
                <div className="bc-stat__value bc-stat__value--green">{balance(afterPending)}</div>
                {eventProfit > 0 && <div className="bc-stat__sub">{$t('Event profit {{amount}}', { amount: money(eventProfit) })}</div>}
                <div className="bc-stat__sub">{$t('If all pending requests are approved')}</div>
            </div>
        </div>
    );
}
